function setNostoTitleHeights() {
  const containers = document.querySelectorAll('.wp-block-acf-nostot .nostot');

  containers.forEach((container) => {
    const columns = container.querySelectorAll('.nosto-column');
    const titles = container.querySelectorAll('.nosto-column__title');

    // Reset heights first
    titles.forEach((title) => {
      title.style.minHeight = '';
    });

    let itemsPerRow = 1;

    if (window.innerWidth >= 1460) {
      itemsPerRow = 4;
    } else if (window.innerWidth > 719) {
      itemsPerRow = 2;
    }

    // No need to calculate for 1 per row
    if (itemsPerRow === 1) return;

    for (let i = 0; i < columns.length; i += itemsPerRow) {
      const rowItems = Array.from(columns).slice(i, i + itemsPerRow);

      let maxHeight = 0;

      rowItems.forEach((item) => {
        const title = item.querySelector('.nosto-column__title');

        if (title) {
          maxHeight = Math.max(maxHeight, title.offsetHeight);
        }
      });

      rowItems.forEach((item) => {
        const title = item.querySelector('.nosto-column__title');

        if (title) {
          title.style.minHeight = `${maxHeight}px`;
        }
      });
    }
  });
}

// Run on load
window.addEventListener('load', setNostoTitleHeights);

// Run on resize
window.addEventListener('resize', setNostoTitleHeights);
